<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import EmPhaseHealth from 'src/components/EnergyMonitoring/sections/EmPhaseHealth.svelte';
	import type { DashEnergyWidgetConfig } from 'src/components/Dashboards/dash-energy-types';

	export let energyConfig: DashEnergyWidgetConfig | undefined;
	export let staticPreview = false;

	$: void energyConfig;
</script>

<EmPhaseHealth {staticPreview} />
